import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

/**
 * Displays Links that has only Icons.
 *
 * @param props - details from component and environment API props
 * @returns {*} HTML content.
 */

const Symbol = (props) => {
    const {
        details: {
            name,
            className,
            textClassname,
            linkClassName,
            additionalProperties,
            symbols,
            path,
            urlReplacements,
            text,
            showUnreadMessage
        },
        environment: {
            links,
            reduxUnreadMessageCount
        },
        index,
        replacements
    } = props;

    const url = urlReplacements ? links[path].processReplacements(urlReplacements) : links[path].processReplacements(replacements);

    return (
        <Fragment>
            {
                <li className={className} data-automation-id={name}>
                    <Fragment>
                        {
                            additionalProperties ?
                                React.createElement(
                                    'a',
                                    {
                                        href: url,
                                        className: linkClassName,
                                        target: additionalProperties.target,
                                        rel: additionalProperties.rel,
                                        id: name + '_' + index,
                                        text: text,
                                        'data-automation-id': name + '_' + index,
                                    },
                                    [
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol}/>)),
                                        showUnreadMessage && reduxUnreadMessageCount > 0 ? <span key="unread-badge-visible" className="unreadRecords">{reduxUnreadMessageCount}</span> :
                                            showUnreadMessage && reduxUnreadMessageCount <= 0 ? <span key="unread-badge-hidden" className="unreadRecords hide"></span> : null
                                    ],
                                    [
                                        <span key={`${name + '_' + index}`} className={textClassname}>
                                            <FormattedMessage id={text}/>
                                        </span>
                                    ]
                                )
                                :
                                React.createElement(
                                    'a',
                                    {
                                        href: url,
                                        className: linkClassName,
                                        id: name + '_' + index,
                                        'data-automation-id': name + '_' + index,
                                    },
                                    [
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol}/>)),
                                        showUnreadMessage && reduxUnreadMessageCount > 0 ? <span key="unread-badge-visible" className="unreadRecords">{reduxUnreadMessageCount}</span> :
                                            showUnreadMessage && reduxUnreadMessageCount <= 0 ? <span key="unread-badge-hidden" className="unreadRecords hide"> </span> : null
                                    ],
                                    [
                                        text ? <span key={`${name + '_' + index}`} className={textClassname}>
                                            <FormattedMessage id={text}/>
                                        </span> : null
                                    ]
                                )
                        }
                    </Fragment>
                </li>
            }
        </Fragment>
    );

};

export default Symbol;